import { render, staticRenderFns } from "./TableCell.html?vue&type=template&id=4beae57d&scoped=true&"
import script from "./TableCell.js?vue&type=script&lang=js&"
export * from "./TableCell.js?vue&type=script&lang=js&"
import style0 from "./TableCell.scss?vue&type=style&index=0&id=4beae57d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beae57d",
  null
  
)

export default component.exports